import { toastService } from "src/libraries/toast";
import { getVacanciesUseCase } from "./getVacanciesUseCase";
import { appStateModel } from "src/entities/appState/AppStateModel";
import { vacanciesService } from "../entity/vacancies/VacanciesService";

export const deleteVacancyUseCase = async (id: number) => {
    try {
        appStateModel.isLoading = true;
        const response = await vacanciesService.delete(id);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getVacanciesUseCase();
            toastService.onSuccess('Success');
        }
    } catch (error) {
        console.warn('deleteVacancyUseCase: ', error);
    } finally {
        appStateModel.isLoading = false;
    }
}   